export const CHANGE_LOCALE = 'app/AppLanguageProvider/CHANGE_LOCALE';
